export default __webpack_public_path__ + "static/media/usuario.8e540afb.png";